import { toCamelCase } from './util';

const generateParentRoutes = (paths, routes) => {
  let i = 0, path, route;
  while (path = paths.shift()) {
    route = routes.find(route => {
      if (!i) {
        if (path === 'index') {
          return route.path === '/';
        }
        return route.path === `/${ path }`;
      }
      return route.path === path;
    });
    if (!route) {
      route = {
        path: !i
          ? path === 'index'
            ? '/'
            : `/${ path }`
          : path,
        component: require('@/page/component/ui/layout').default,
        children: []
      };
      routes.push(route);
    }
    routes = route.children;
    i++;
  }
  return routes;
};

/*
 根据url,生成route
 目录为index的时候，表示根目录
 index.vue 为默认子组件
 _.vue 为父组件
*/
export const generateRoutes = ctx => {
  let routes = [];
  ctx.keys().forEach(filename => {
    let parentRouteChildren, comp;
    const paths = filename.split(/\//);
    // 删掉/前面的.
    paths.shift();
    // 获取最后一个元素，为组件路径
    let [ compUrl ] = paths.pop().split('.');
    // 如果组件名是-表示，则转成驼峰
    // compUrl = toCamelCase(compUrl);
    //comp = ctx(filename);
    // console.log(filename, 'fl');
    // 如果paths只有1个值，并且当前filepath为_，则为根目录
    if (paths.length == 1 && compUrl === '_') {
      routes.push({
        path: `/`,
        component: () => Promise.resolve(ctx(filename)), //comp.default || comp,
        children: []
      });
    } else {
      // 创建组件路径的父Route
      parentRouteChildren = generateParentRoutes(paths, routes);
      // 如果组件名为index，则为默认子组件
      if (compUrl === 'index') {
        compUrl = '';
      }
      parentRouteChildren.push({
        path: compUrl,
        component: () => Promise.resolve(ctx(filename)) //comp.default || comp
        // component: () => comp.default || comp  //
      });
    }
  });
  return routes;
};

/*
 注册全局组件,mixins等
*/
export const registerGlobal = (ctx, func) => {
  ctx.keys().forEach(filename => {
    let inst = ctx(filename);
    inst.default && (inst = inst.default);
    func(inst);
  });
};

/*
 获取组件的配置项
*/
export const getCompOptions = (name, type, elTag = 'el-input', elProps) => ({
  name,
  type,
  elTag,
  elProps: {
    size: 'small',
    ...elProps
  }
});

/*
 获取table heads配置项
*/
export const getTableHeadOptions = (label, prop, elProps) => {
  if (typeof prop === 'string') {
    prop = ({ prop });
  }
  return { label, ...prop, ...elProps };
};

/*
 根据配置项获取组件的key=>value Model
*/
export const getModelToOption = arr => {
  arr = Array.prototype.concat.apply([], arr);
  return arr.reduce((memo, ele) => {
    memo[ ele.name ] = ele.value === void 0
      ? new ele.type().valueOf()
      : ele.value;
    return memo;
  }, {});
};

/*
 根据配置项获取组件的rule
*/
export const getRulesToOption = arr => {
  arr = Array.prototype.concat.apply([], arr);
  return arr.reduce((memo, ele) => {
    memo[ ele.name ] = ele.rules;
    return memo;
  }, {});
};

/*
 获取表单组件的配置项
*/
export const getFormCompOptions = (props, elTag = 'el-input', elProps, rules, children) => ({
  ...props,
  elTag,
  elProps: {
    size: 'small',
    clearable: true,
    ...elProps
  },
  rules,
  children
});
